import React, {useEffect, useState} from "react";
import useSerializedRefresh from "../../../useSerializedRefresh";
import ApiService from "../../../../../services/ApiService";
import ProgressBar from "@ramonak/react-progress-bar";
import {notification, Typography} from "antd";
import {uuidv4} from "../../../../../utils";
import {getDeviseSymbol} from "../../../../../i18n";

const {Text,Title}=Typography

export default function ScreenDonSection({context,campagneData,})
{
    const [loading,setLoading]=useState(true)
    const [dons,setDons]=useState([])

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:2 })

    const partnerMontant=campagneData?.partnerMontant || 1

    let donorName=campagneData.config?.donorName || "Parrainages"

    const screenOptions=campagneData?.screenOptions || {}


    const getDisplayName=(campagneExtraData={})=>{
        return campagneExtraData?.displayName || "Anonyme"
    }

    const getDons=async ()=>{
        let url="/campagne/donors/"+campagneData.id

        const res=await ApiService.get(url)
        let _dons=res.data

        if(screenOptions.minMontant){
            _dons=_dons.filter(i=>i.montant>=screenOptions.minMontant)
        }

        setDons(_dons)
        setLoading(false)
    }

    useSerializedRefresh(getDons, campagneData?._liveRevision)


    if(loading){
        return null
    }

    return (
        <div style={{overflow:"visible",width:"100%",height:"15vh",display:"flex",alignItems:"center",flexDirection:"row-reverse",gap:30,padding:"0 8vw"}}>
            {dons.map((d,index)=>{

                //console.log(index)

                let className="screen-don-card"

                if(index<4){
                    className+=" screenDonFadeIn"
                }else{
                    className+=" screenDonFadeOut"
                }

                //console.log(className)

                return(
                    <div
                        key={d.id}
                        className={className}
                        style={{
                            flexDirection:"column",
                            alignItems:"center",
                            borderRadius:30,
                            border:"none",
                            backgroundColor:"rgb(245,225,174)",
                        }}
                    >

                        <div style={{padding: "0px 5%",width:"100%"}}>
                            <div style={{
                                borderRadius: 20,
                                backgroundColor: "rgb(196,150,110)",
                                width: "100%",
                                textAlign: "center"
                            }}>

                            <span style={{
                                color: "#4e0b22",
                                fontSize: "4vh",
                                textAlign: "center",
                                fontWeight: "bold",
                                fontFamily:"Noir-Medium"
                            }}>{formater.format(d.montant)}€</span>

                            </div>
                        </div>


                        <span style={{
                            color: "#4e0b22",
                            fontSize: "3vh",
                            textAlign: "center",
                            fontFamily:"Noir-Light"
                        }}>{getDisplayName(d.campagneExtraData)}</span>
                    </div>
                )
            })}
        </div>
    )
}
